import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';
import {firstNestedSymbolControl, TextControl} from '../../../models/uiArtefakt';
import {ValidationService} from '../../../services/validation.service';
import {UiUpdateService} from '../../../services/ui-update.service';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ISymbol, TranslationService} from '@lv1871/core';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {MeldungPipe} from '../../../pipes/meldung.pipe';
import {EventService} from '../../../services/event.service';

@Component({
    selector: 'lv-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    providers: [MeldungPipe],
    standalone: false
})
export class TextareaComponent implements OnInit, AfterViewInit {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  @ViewChild('textarea', {static: true})
  private _textarea: NgModel;

  public charactersCount: number;
  public counter: string;
  public isDisabled: boolean = false;
  public showUntruncatedError: boolean = false;
  public uiAusrichtung: UIAusrichtung;
  public nestedSymbol: ISymbol;
  public showInfotextCollapsable: boolean = false;
  public extendedHint: any;

  private _uiArtefakt: TextControl;

  constructor(private _validationService: ValidationService, private _shellConfigService: ShellConfigService,
              private _translationService: TranslationService, private _uiUpdateService: UiUpdateService,
              private _meldungPipe: MeldungPipe, private _eventService: EventService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): TextControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: TextControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  public infotextCollapsableChange(event) {
    this.showInfotextCollapsable = event;
  }

  public ngOnInit(): void {
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.nestedSymbol = firstNestedSymbolControl(this.uiArtefakt.UIArtefakt);
    this._validationService.registerForm(this.uiArtefakt, this._ngForm);
    this.charactersCount = this.uiArtefakt.WertEingabe ? this.uiArtefakt.WertEingabe.length : 0;
    if (!!this.uiArtefakt.AnzahlZeichenMaximum) {
      this.counter = `${this.charactersCount} von ${this.uiArtefakt.AnzahlZeichenMaximum}`;
    }

  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public changeValue(value: any) {
    if (value + '' === this.uiArtefakt.WertEingabe + '') {
      return;
    }
    if (!value) {
      this.uiArtefakt.WertEingabe = null;
      this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
      return;
    }

    const max = this._uiArtefakt.AnzahlZeichenMaximum;
    const min = this._uiArtefakt.AnzahlZeichenMinimum;
    if(!!max && value.length >= max){
      this.extendedHint = !!this._uiArtefakt.Hinweis ?
          this._translationService.translate('ERRORS.INPUT.MAXIMUM_CHARACTERS', {x: max}) + '<br>' + this._uiArtefakt.Hinweis :
          this._translationService.translate('ERRORS.INPUT.MAXIMUM_CHARACTERS', {x: max});
    } else if(!!min && value.length < min){
      this.extendedHint = !!this._uiArtefakt.Hinweis ?
          this._translationService.translate('ERRORS.INPUT.MINIMUM_CHARACTERS', {x: min}) + '<br>' + this._uiArtefakt.Hinweis :
          this._translationService.translate('ERRORS.INPUT.MINIMUM_CHARACTERS', {x: min});
    } else {
      this.extendedHint = this._uiArtefakt.Hinweis;
    }

    this.uiArtefakt.WertEingabe = value;
    this._uiUpdateService.valueChangedSubject$.next(this.uiArtefakt);
  }

  public getError(): string {
    if (this.uiArtefakt.PflichtfeldJN && this._textarea?.touched && !this.uiArtefakt.WertEingabe) {
      const requiredError = this._translationService.translate('ERRORS.REQUIRED');
      return !!this.uiArtefakt.FehlertextPflichtfeld ? this.uiArtefakt.FehlertextPflichtfeld : requiredError;
    }
    if (this.uiArtefakt.UIMeldung?.length && this._textarea?.touched) {
      return this._meldungPipe.getMostImportantMeldungstext(this.uiArtefakt.UIMeldung);
    }
    this.showUntruncatedError = false;
    return null;
  }

  public onErrorClick() {
    this.showUntruncatedError = !this.showUntruncatedError;
  }

  onBlur() {
    if(!!this._uiArtefakt.ReferenzIdentifikator){
      this._eventService.refIdentTouchedOrDirty$.next(this._uiArtefakt.ReferenzIdentifikator);
    }
  }
}
